import {Component, inject, OnInit} from '@angular/core';
import {PrimeNG} from 'primeng/config';
import {RouterOutlet} from '@angular/router';
import {ModuleRegistry} from 'ag-grid-community';
import {AllEnterpriseModule, LicenseManager} from 'ag-grid-enterprise';
import {PrimengCustomizationsService} from "./shared/services/primeng-customizations.service";
import {AppUpdateService} from './shared/services/app-update.service';

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-109794}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{AlphaGR}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{IMS}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{IMS}_need_to_be_licensed___{IMS}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{10_November_2026}____[v3]_[01]_MTc5NDI2ODgwMDAwMA==4b00f9ca74273c4e66a334793cdc42dd");

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    private primengConfig = inject(PrimeNG);
    private primengCustomizationsService = inject(PrimengCustomizationsService);
    private appUpdateService = inject(AppUpdateService);

    ngOnInit(): void {
        this.primengConfig.ripple.set(true);
        this.primengCustomizationsService.registerCustomizations();
        this.appUpdateService.init();
    }
}
